import PropTypes from 'prop-types';
import { Avatar, Badge, Box } from '@mui/material';
import { stringToColor } from '../../util/formatHelper';

const initialsOf = (name = '') => {
  const parts = String(name).trim().split(/\s+/).filter(Boolean);
  if (parts.length === 0) return '?';
  if (parts.length === 1) return parts[0].slice(0, 2).toUpperCase();
  return (parts[0][0] + parts[parts.length - 1][0]).toUpperCase();
};

// Circular avatar showing a colleague's initials on a deterministic colour, with
// an optional online presence dot.
export default function UserAvatar({ name, size = 40, online = false, showPresence = true }) {
  const avatar = (
    <Avatar
      sx={{
        width: size,
        height: size,
        bgcolor: stringToColor(name || '?'),
        color: '#fff',
        fontSize: size * 0.38,
        fontWeight: 600,
      }}
    >
      {initialsOf(name)}
    </Avatar>
  );

  if (!showPresence) return avatar;

  return (
    <Badge
      overlap='circular'
      anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
      badgeContent={
        <Box
          sx={{
            width: Math.max(10, size * 0.28),
            height: Math.max(10, size * 0.28),
            borderRadius: '50%',
            backgroundColor: online ? 'success.main' : 'grey.500',
            border: theme => `2px solid ${theme.palette.background.paper}`,
          }}
        />
      }
    >
      {avatar}
    </Badge>
  );
}

UserAvatar.propTypes = {
  name: PropTypes.string,
  size: PropTypes.number,
  online: PropTypes.bool,
  showPresence: PropTypes.bool,
};
